export default "__VITE_ASSET__CnTZu4YZ__"